import React from 'react';

import MDSnackbar from "../../../materialDashboard/components/MDSnackbar";

const NotificationSnackbar = props => {
    const {notification, onClose} = props;

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        onClose()
    };

    const content = notification.messages.length > 0 ? notification.messages.map((m, i) => <div key={i}>{m}</div>) : null;

    return (
        <MDSnackbar
            color={notification.severity}
            icon={notification.severity === "error" ? "warning" : "check_circle"}
            title={notification.title}
            dateTime=""
            content={content}
            open={true}
            onClose={handleClose}
            close={handleClose}
            bgWhite
            autoHideDuration={100000}
        />
    );
};

export {NotificationSnackbar}